import { Textarea } from '@chiroup/components/form/Textarea';
import { SurveyQuestionAnswer, SurveyQuestionTypeOptions } from '@chiroup/core/types/Survey.type';
import React, { useState } from 'react';
import { questionContentVerbiage } from './SurveyQuestionContent';

type Props = {
  id: string;
  onSelect: (val: SurveyQuestionAnswer) => Promise<void>;
  disabled: boolean;
  language?: 'en' | 'es';
  primaryColor: string;
  textOptions?: SurveyQuestionTypeOptions;
  forceAnswer?: boolean;
  hideNext?: boolean;
};

export const SurveyQuestionTextarea: React.FC<Props> = ({
  id,
  onSelect,
  disabled,
  language = 'en',
  primaryColor,
  textOptions,
  forceAnswer = true,
  hideNext = false,
}) => {
  const [val, setVal] = useState<string>('');

  // Inside a group there is no per-question Next button, so stream the value up
  // as the patient types — otherwise the group's single submit never receives
  // it. Emit even when empty so clearing the field propagates too.
  const onChange = async (next: string) => {
    setVal(next);
    if (hideNext) {
      await onSelect({ type: 'input', value: next });
    }
  };

  const handleSubmit = async () => {
    await onSelect({ type: 'input', value: val });
    setVal('');
  };

  return (
    <>
      <Textarea
        name={`question-${id}`}
        className=""
        value={val}
        onChange={onChange}
        disabled={disabled}
        autoFocus
        placeHolder={textOptions?.placeHolder}
      />
      {!hideNext && (
        <button
          disabled={disabled || (forceAnswer && !val)}
          onClick={handleSubmit}
          className="cursor-pointer rounded-md shadow items-center justify-center px-5 py-3 border border-transparent text-base font-medium text-white hover:opacity-90 focus:outline-none focus:ring transition duration-150 ease-in-out mt-8"
          style={{
            backgroundColor: primaryColor,
          }}
          data-cy="text-area-next-button"
        >
          {questionContentVerbiage[language === 'es' ? 'es' : 'en'].next}
        </button>
      )}
    </>
  );
};
